import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { isValidEmail, showToast } from "../../utils/helper";
import { trackEvent } from "../../utils/analytics";
import {
  signupAction,
  verifySignupAction,
} from "../../Store/Actions/AuthActions";
import { API } from "../../utils/api";
import ResendOtp from "../Component/ResendOtp";

const SignUp = ({
  asModal = false,
  redirect = false,
  changeStep = null,
  onSuccess = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const { redirectUrl } = location.state || {};

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
    type: "credentials",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [verifyEmail, setEmailVerification] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const validateForm = () => {
    const errs = {};

    if (!data.name || data.name === "") {
      errs.name = "Please enter your name";
    }

    if (!data.email || data.email === "") {
      errs.email = "Please enter your email address";
    } else if (data.email && !isValidEmail(data.email)) {
      errs.email = "Please enter a valid email address";
    }

    if (!data.password || data.password === "") {
      errs.password = "Please enter your password";
    } else if (data.password.length < 6) {
      errs.password = "Password must be at least 6 characters";
    } else if (!data.cpassword || data.cpassword === "") {
      errs.cpassword = "Please enter your confirm password";
    } else if (data.password !== data.cpassword) {
      errs.cpassword = "Please ensure both passwords match.";
    }

    return errs;
  };

  const verfiyEmail = () => {
    const otpErrors = {};

    if (!data.otp || data.otp === "") {
      otpErrors.otp = "Please enter verification code";
    } else if (String(data.otp).length !== 6) {
      otpErrors.otp = "Please enter valid verification code";
    }

    setErrors(otpErrors);

    if (Object.keys(otpErrors).length > 0) return;

    if (loading) return;

    setLoading(true);

    verifySignupAction(data, dispatch)
      .then((res) => {
        if (res.type === "success") {
          trackEvent("web_signup_verified", { method: "email" });
          if (res.message) showToast("success", res.message);
          if (onSuccess) onSuccess();
        } else {
          showToast("error", res.message || "Verification failed");
        }
      })
      .catch((err) => {
        showToast("error", err?.message || "Verification failed");
      })
      .finally(() => setLoading(false));
  };

  const submitForm = () => {
    const errs = validateForm();
    setErrors(errs);

    if (!loading && Object.entries(errs).length === 0) {
      setLoading(true);

      trackEvent("web_signup_submit", { method: "email" });
      signupAction({ ...data, device_type: "web" })
        .then((res) => {
          if (res.type === "success") {
            trackEvent("web_signup_success", { method: "email" });
            if (res.message) showToast("success", res.message);
            setEmailVerification(true);
          } else {
            trackEvent("web_signup_failed", { method: "email" });
            showToast("error", res.message || "Something went wrong");
          }
        })
        .catch((err) => {
          showToast("error", err?.message || "Something went wrong");
        })
        .finally(() => setLoading(false));
    }
  };

  const onChagne = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const redirectTo = (url) => {
    navigate(url);
  };

  useEffect(() => {
    if (isAuthenticated) {
      if (redirect) {
        if (redirectUrl) {
          redirectTo(redirectUrl);
        }
      } else if (!onSuccess) {
        if (user.type === "user") {
          redirectTo("/user/spots");
        } else {
          redirectTo("/admin/spots");
        }
      }
    }
  }, [isAuthenticated]);

  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          if (verifyEmail) {
            verfiyEmail();
          } else {
            submitForm();
          }
        }}
      >
        {verifyEmail && (
          <>
            <Form.Group className="form-group with-icon">
              <i className="far fa-envelope" />
              <Form.Control
                disabled
                type="email"
                name="email"
                value={data.email}
                placeholder="Your Email"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.email}
              />
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="form-group with-icon">
              <i className="fas fa-lock" />
              <Form.Control
                type="text"
                name="otp"
                value={data.otp || ""}
                placeholder="Enter verification code"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.otp}
              />
              {errors.otp && (
                <Form.Control.Feedback type="invalid">
                  {errors.otp}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <ResendOtp
              onResend={() =>
                API.resendSignupOtp({ email: data.email }).then((res) => {
                  if (res.type === "success") {
                    showToast(
                      "success",
                      res.message || "Verification code sent",
                    );
                  } else {
                    showToast(
                      "error",
                      res.message || "Failed to resend code",
                    );
                  }
                })
              }
            />

            <div class="button-wrapper">
              <Button type="submit" className="btn btn-medium solid">
                {!loading && <span>Verify</span>}
                {loading && (
                  <i className="fas fa-spinner fa-pulse loadingIcon" />
                )}
              </Button>
            </div>
          </>
        )}

        {!verifyEmail && (
          <>
            <Form.Group className="form-group with-icon">
              <i className="far fa-user" />
              <Form.Control
                type="text"
                name="name"
                value={data.name}
                placeholder="Your name"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.name}
              />
              {errors.name && (
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="form-group with-icon">
              <i className="far fa-envelope" />
              <Form.Control
                type="email"
                name="email"
                value={data.email}
                placeholder="Your Email"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.email}
              />
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="form-group with-icon">
              <i className="fas fa-phone" />
              <Form.Control
                type="text"
                name="phone"
                value={data.phone || ""}
                placeholder="Your phone"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.phone}
              />
              {errors.phone && (
                <Form.Control.Feedback type="invalid">
                  {errors.phone}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="form-group with-icon">
              <i className="fas fa-lock" />
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                value={data.password}
                placeholder="Your Password"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.password}
              />
              <button
                type="button"
                className="password-toggle"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                <i className={`far ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
              </button>
              {errors.password && (
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="form-group with-icon">
              <i className="fas fa-lock" />
              <Form.Control
                type={showCPassword ? "text" : "password"}
                name="cpassword"
                value={data.cpassword}
                placeholder="Your Confirm Password"
                onChange={(e) => onChagne(e)}
                isInvalid={!!errors.cpassword}
              />
              <button
                type="button"
                className="password-toggle"
                aria-label={showCPassword ? "Hide password" : "Show password"}
                onClick={() => setShowCPassword((v) => !v)}
              >
                <i className={`far ${showCPassword ? "fa-eye-slash" : "fa-eye"}`} />
              </button>
              {errors.cpassword && (
                <Form.Control.Feedback type="invalid">
                  {errors.cpassword}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <div class="button-wrapper">
              <Button type="submit" className="btn btn-medium solid">
                {!loading && <span>Signup</span>}
                {loading && (
                  <i className="fas fa-spinner fa-pulse loadingIcon" />
                )}
              </Button>
            </div>

            <div className="guide-links ml-auto">
              Already have an account?{" "}
              <span className="link" onClick={() => changeStep("Login")}>
                Login Now
              </span>
            </div>
          </>
        )}
      </Form>
    </>
  );
};

export default SignUp;
